import React from "react";

const About = () => {
    return (
        <section id="about" className="about" data-aos="fade-left">
            <div className="about-text">
                <h2>About Us</h2>
                <p>Technophilia 3.0 is a dynamic fusion of technology and creativity, bringing together innovators, problem-solvers, and enthusiasts from all domains. Designed to challenge minds and spark inspiration, this edition features a diverse range of technical and non-technical events, ensuring there’s something for everyone.  </p>
                <p>From  coding challenges, and tech quizzes to design battles, business strategy games, and fun-filled interactive sessions, Technophilia 3.0 is a celebration of skills, knowledge, and collaboration. Whether you're a tech geek eager to push boundaries or a creative thinker looking for an engaging experience, this is the platform to showcase your talent.</p>
                <p>Join us and be part of an electrifying journey where innovation meets excitement. Let’s learn, compete, and create the future—together!</p>
            </div>
            <img src="/images/IMG_4536.jpg" alt="About Us" data-aos="fade-left"/>
        </section>
    );
};

export default About;
